import { render, staticRenderFns } from "./AnswerQuestion.vue?vue&type=template&id=28aab4e2"
import script from "./AnswerQuestion.vue?vue&type=script&lang=js"
export * from "./AnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./AnswerQuestion.vue?vue&type=style&index=0&id=28aab4e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports